import { Service, ServiceLimitType } from '../models/service'

export const getServiceMinimumQuantity = (
  service: Service,
  selectedSeatsAmount: number,
  dayDifference: number,
  spotsAmount?: number
) => {
  if (service.hasLimit && service.availableQuantity === 0) {
    return 0
  }

  if (service.minimumLimitType === ServiceLimitType.NUMBER_OF_PIECES) {
    return selectedSeatsAmount
  } else if (service.minimumLimitType === ServiceLimitType.NUMBER_OF_DAYS) {
    return dayDifference
  } else return service.minimumQuantity * (spotsAmount ?? 1)
}
